export const NothingHere = () => {

return(<div className="flex justify-center flex-col items-center">
        <img className="w-1/2 my-5" src="/nothing.svg" alt="icon" />
        <h1 className="text-3xl font-bold text-center text-blue-600">Uw winkelmandje is nog leeg</h1>
        <p className="my-5 text-lg text-gray-600 font-medium text-center">Het lijkt erop dat u nog niets heeft toegevoegd.<br />Voeg eerst een item toe.</p>

</div>)

}